<template>
  <div class="start-layout">
    <main class="main">
      <slot />
    </main>
  </div>
</template>

<script lang="ts" src="./StartScreenLayout.ts">

</script>

<style scoped lang="scss" src="./StartScreenLayout.scss">

</style>
